import React from 'react';
import PropTypes from 'prop-types';

// These are one-off icons for the docs sidenav so they live here instead of Volt.
// Add any new sidenav icons here.

const SidenavIcon = ({ type, color }) => {
  switch (type) {
    case '3d-secure':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 6C20 6 15.5 5 12 2C9.00001 5 4 6 4 6L4.00001 14C9 22 12 22 12 22C12 22 15 22 20 14L20 6ZM18 13.4202L18 7.50367C17.5831 7.36618 17.0991 7.19368 16.5697 6.98195C15.2693 6.46178 13.6487 5.68639 12.0677 4.57868C10.5679 5.70809 8.91851 6.48187 7.59296 6.99169C7.0058 7.21753 6.46371 7.39849 6 7.53985L6.00001 13.4202C8.26373 16.9501 9.99406 18.6136 11.0513 19.3825C11.494 19.7044 11.813 19.8655 12 19.9436C12.187 19.8655 12.506 19.7044 12.9487 19.3825C14.006 18.6136 15.7363 16.9501 18 13.4202Z"
            fill={color}
          />
        </svg>
      );
    case 'account-holders':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 14H8C6.89543 14 6 14.8954 6 16V19H18V16C18 14.8954 17.1046 14 16 14ZM8 12C5.79086 12 4 13.7909 4 16V21H20V16C20 13.7909 18.2091 12 16 12H8Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
            fill={color}
          />
        </svg>
      );
    case 'card-network-certifications':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7071 9.70715L10.5 15.9143L7.29289 12.7072L8.70711 11.2929L10.5 13.0858L15.2929 8.29294L16.7071 9.70715Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4.28796L5 8.17685L5 15.8232L12 19.7121L19 15.8232L19 8.17685L12 4.28796ZM4.02871 6.42854L11.0287 2.53965C11.6328 2.20407 12.3672 2.20407 12.9713 2.53965L19.9713 6.42854C20.6062 6.78128 21 7.45052 21 8.17685V15.8232C21 16.5496 20.6062 17.2188 19.9713 17.5716L12.9713 21.4604C12.3672 21.796 11.6328 21.796 11.0287 21.4604L4.02871 17.5716C3.39378 17.2188 3 16.5496 3 15.8232V8.17685C3 7.45052 3.39378 6.78128 4.02871 6.42854Z"
            fill={color}
          />
        </svg>
      );
    case 'building-your-card-program':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 5H5L5 19H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z"
            fill={color}
          />
          <path d="M7 7H9V9H7V7Z" fill={color} />
          <path d="M10 7H17V9H10V7Z" fill={color} />
          <path d="M7 11H9V13H7V11Z" fill={color} />
          <path d="M7 15H9V17H7V15Z" fill={color} />
          <path d="M10 11H14V13H10V11Z" fill={color} />
        </svg>
      );
    case 'cards':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 10V12H10V10H8ZM7 8C6.44772 8 6 8.44772 6 9V13C6 13.5523 6.44772 14 7 14H11C11.5523 14 12 13.5523 12 13V9C12 8.44772 11.5523 8 11 8H7Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 6H4V18H20V6ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4Z"
            fill={color}
          />
        </svg>
      );
    case 'credit':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0235 14.0235L17.7815 12L14.0235 9.97648L12 6.21852L9.97648 9.97648L6.21852 12L9.97648 14.0235L12 17.7815L14.0235 14.0235ZM12 22L8.5 15.5L2 12L8.5 8.5L12 2L15.5 8.5L22 12L15.5 15.5L12 22Z"
            fill={color}
          />
        </svg>
      );
    case 'digital-wallets':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 8H9V15H19V8ZM9 6C7.89543 6 7 6.89543 7 8V15C7 16.1046 7.89543 17 9 17H19C20.1046 17 21 16.1046 21 15V8C21 6.89543 20.1046 6 19 6H9Z"
            fill={color}
          />
          <path d="M8 10H17V12H8V10Z" fill={color} />
          <path
            d="M5 4H13V6H15V4C15 2.89543 14.1046 2 13 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H13C14.1046 22 15 21.1046 15 20V19H13V20H5L5 4Z"
            fill={color}
          />
        </svg>
      );
    case 'disputes':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5C3 3.34315 4.34315 2 6 2H13C14.6569 2 16 3.34315 16 5V6H14V5C14 4.44772 13.5523 4 13 4H6C5.44772 4 5 4.44772 5 5V13C5 13.5523 5.44772 14 6 14H15V16H6C4.34315 16 3 14.6569 3 13V5Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 19C21 20.6569 19.6569 22 18 22H11C9.34315 22 8 20.6569 8 19V18H10V19C10 19.5523 10.4477 20 11 20H18C18.5523 20 19 19.5523 19 19V11C19 10.4477 18.5523 10 18 10H9V8H18C19.6569 8 21 9.34315 21 11V19Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5858 15L12.2929 12.7071L13.7071 11.2929L17.4142 15L13.7071 18.7071L12.2929 17.2929L14.5858 15Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.41421 9L11.7071 11.2929L10.2929 12.7071L6.58579 9L10.2929 5.29289L11.7071 6.70711L9.41421 9Z"
            fill={color}
          />
        </svg>
      );
    case 'getting-started':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 3C4.44772 3 4 3.44771 4 4V22H6V4C6 3.44772 5.55228 3 5 3Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 11L22 5H4V17H22L18 11ZM18.263 15L15.5963 11L18.263 7H6V15H18.263Z"
            fill={color}
          />
        </svg>
      );
    case 'home':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 19V11.8981L12 5.6759L5 11.8981L5 19H19ZM3.67127 10.4033C3.2443 10.7828 3 11.3268 3 11.8981V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V11.8981C21 11.3268 20.7557 10.7828 20.3287 10.4033L13.3287 4.18108C12.571 3.50751 11.429 3.50751 10.6713 4.18108L3.67127 10.4033Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 14H10V19H14V14ZM10 12C8.89543 12 8 12.8954 8 14V19C8 20.1046 8.89543 21 10 21H14C15.1046 21 16 20.1046 16 19V14C16 12.8954 15.1046 12 14 12H10Z"
            fill={color}
          />
        </svg>
      );
    case 'just-in-time-funding':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill={color}
          />
          <path
            d="M13 6.08296C12.6748 6.0284 12.3407 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.6593 17.9716 11.3252 17.917 11H15.874C15.9562 11.3196 16 11.6547 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C12.3453 8 12.6804 8.04375 13 8.12602V6.08296Z"
            fill={color}
          />
          <path d="M11 6.08296L13 7V13H11V6.08296Z" fill={color} />
          <path d="M11 11H17V13H11V11Z" fill={color} />
        </svg>
      );
    case 'marqeta-dashboard':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 6H4V18H20V6ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4Z"
            fill={color}
          />
          <path d="M8 4H10V20H8V4Z" fill={color} />
          <path d="M14 13H16V20H14V13Z" fill={color} />
          <path d="M20 11V13H10V11L20 11Z" fill={color} />
        </svg>
      );
    case 'partner-integrations':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.4408 4.10238C21.7831 4.27047 22 4.61864 22 5.00001V13.4818C22 14.0341 21.5523 14.4818 21 14.4818C21.0024 14.4818 20.9991 14.4822 20.9902 14.4831C20.9554 14.4867 20.8348 14.4991 20.6205 14.5351C20.379 14.5758 20.0713 14.6374 19.7441 14.7194C19.2498 14.8432 18.7837 14.9961 18.434 15.1599C18.1487 16.4667 16.995 17.3319 16.1092 17.8559C15.5537 18.1845 14.9774 18.4519 14.5034 18.6627C14.3698 18.7221 14.2497 18.7749 14.1419 18.8223C13.8324 18.9583 13.6249 19.0495 13.4938 19.1239C12.6214 19.6193 11.8135 19.4263 11.2607 19.1523C11.173 19.1089 11.0894 19.0624 11.0115 19.016C10.8852 19.1453 10.7466 19.2731 10.5956 19.3911C10.2317 19.6752 9.75491 19.9342 9.16909 19.9894C8.5697 20.0458 7.97166 19.8781 7.39713 19.5082C7.33137 19.4659 7.27081 19.416 7.21667 19.3596L4.27827 16.2956C3.90168 15.9029 3.90814 15.2812 4.29281 14.8964C4.31767 14.8716 4.34595 14.8429 4.37745 14.8109C4.46343 14.7237 4.57337 14.6122 4.70301 14.4878L4.69847 14.4818H3C2.44772 14.4818 2 14.0341 2 13.4818V5.56546C2 5.21674 2.18167 4.89319 2.47942 4.71165C2.77716 4.53011 3.14798 4.51679 3.45799 4.6765L5.21475 5.58158C6.20612 5.13538 7.5503 4.66028 8.81389 4.50249C9.54668 4.41098 10.348 4.41327 11.0598 4.66818C11.4556 4.80991 11.817 5.02883 12.1121 5.33268C12.4415 5.05412 12.7984 4.79414 13.1421 4.64657C13.6423 4.4318 14.2282 4.43149 14.711 4.47604C15.2268 4.52365 15.7874 4.64033 16.3264 4.78216C17.1528 4.99962 17.9918 5.29322 18.6501 5.55217L20.3885 4.20875C20.6903 3.97555 21.0984 3.93429 21.4408 4.10238ZM10.6818 6.73083C10.6094 6.65345 10.5136 6.59694 10.3856 6.5511C10.0941 6.44671 9.64966 6.41366 9.06172 6.48707C7.89408 6.63288 6.53608 7.14807 5.63902 7.59245C5.35433 7.73348 5.01956 7.73084 4.73714 7.58533L4 7.20557V12.4818H5.19512C5.50799 12.4818 5.80283 12.6283 5.99189 12.8776L6.32287 13.314C6.99609 13.0003 7.86333 12.8204 8.77056 13.2395C8.83026 13.2671 8.88709 13.3005 8.94023 13.3393L11.7821 15.4108C12.0403 15.599 12.193 15.8994 12.193 16.2189L12.193 17.194C12.193 17.2546 12.1875 17.3148 12.1767 17.3737C12.268 17.416 12.3257 17.4275 12.3599 17.4293C12.3841 17.4305 12.4264 17.4301 12.5062 17.3848C12.7354 17.2546 13.0834 17.102 13.4236 16.9529C13.514 16.9133 13.6037 16.8739 13.6906 16.8353C14.1479 16.6319 14.6382 16.4023 15.091 16.1345C16.0893 15.544 16.5 15.0068 16.5 14.5431C16.5 14.4804 16.5059 14.4184 16.5173 14.3579C16.3907 14.2882 16.2773 14.1899 16.1874 14.0647L14.3453 11.4965C14.2262 11.5753 14.1035 11.6541 13.9807 11.7311C13.4338 12.0736 12.7679 12.4498 12.175 12.7044C11.1151 13.1594 10.154 12.6174 9.59944 12.1634C9.00844 11.6796 8.54165 11.0379 8.28218 10.5923C8.07692 10.2398 8.10632 9.79802 8.35647 9.47584C8.88134 8.79982 9.73374 7.75951 10.595 6.8246C10.6239 6.79328 10.6528 6.76201 10.6818 6.73083ZM17.9566 13.1894C18.4015 13.0126 18.8629 12.8784 19.258 12.7794C19.5211 12.7134 19.7736 12.6587 20 12.615V7.0366L19.4164 7.48764C19.1291 7.70965 18.744 7.75851 18.4104 7.61527C17.785 7.34677 16.779 6.96933 15.8175 6.71632C15.3357 6.58956 14.8921 6.50125 14.5272 6.46758C14.3457 6.45083 14.2003 6.44923 14.0898 6.45791C13.9785 6.46666 13.9332 6.48356 13.9312 6.48433C13.8299 6.52779 13.5915 6.68635 13.2184 7.02149C12.8699 7.3346 12.4737 7.73714 12.066 8.1797C11.466 8.83094 10.8652 9.54262 10.3907 10.1295C10.534 10.305 10.6968 10.4771 10.8664 10.6159C11.0406 10.7585 11.18 10.8313 11.2745 10.8598C11.3496 10.8824 11.3731 10.8722 11.3848 10.8671C11.3852 10.8669 11.3856 10.8667 11.386 10.8666C11.8467 10.6688 12.4156 10.3513 12.9192 10.036C13.1675 9.88048 13.3901 9.73163 13.565 9.60684C13.6526 9.54441 13.7246 9.49055 13.7799 9.4469C13.8075 9.42519 13.8289 9.40753 13.8449 9.39387C13.86 9.38096 13.8669 9.37445 13.8677 9.37374C13.8677 9.37366 13.8677 9.37369 13.8677 9.37374C14.0762 9.17004 14.3634 9.06746 14.6538 9.09293C14.9442 9.11841 15.2091 9.26935 15.379 9.50625L17.8126 12.899C17.8778 12.9899 17.9255 13.088 17.9566 13.1894ZM10.193 16.7274L7.86085 15.0274C7.63408 14.9542 7.33377 15.0007 6.89662 15.2756C6.72617 15.3828 6.5652 15.5059 6.41477 15.6339L8.56942 17.8806C8.78204 17.9996 8.91244 18.0047 8.98157 17.9982C9.07351 17.9895 9.19708 17.9456 9.36453 17.8148C9.53599 17.6809 9.70867 17.491 9.89071 17.2589C9.92756 17.2119 9.96347 17.1649 9.99904 17.1177C10.0071 17.1064 10.0154 17.0954 10.0239 17.0845C10.0652 17.0293 10.1063 16.9736 10.1481 16.9168L10.1544 16.9083C10.1671 16.8911 10.1799 16.8737 10.193 16.856L10.193 16.7274Z"
            fill={color}
          />
        </svg>
      );
    case 'pci-compliance':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 11H5L5 19H19V11ZM5 9C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 9V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V9H15ZM12 2C9.23858 2 7 4.23858 7 7V11H17V7C17 4.23858 14.7614 2 12 2Z"
            fill={color}
          />
        </svg>
      );
    case 'marqeta-in-europe':
    case 'powered-by-marqeta':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.52793 18H4C2.89543 18 2 17.1046 2 16V4C2 2.89543 2.89543 2 4 2H19C20.1046 2 21 2.89543 21 4V11.2451C22.1787 11.7759 23 12.9665 23 14.35V18.6C23 20.4778 21.4872 22 19.6211 22H16.2422C13.7081 22 13.4182 21.9146 12.4286 20.9188L9.52793 18ZM4 4H7V12H9V4H19V10.95H17.087V8.55C17.087 7.14167 15.9524 6 14.5528 6C13.1532 6 12.0186 7.14167 12.0186 8.55V13.3391C11.4308 12.9105 10.7012 12.7673 10.0186 12.9093C9.55091 13.0066 9.10521 13.2379 8.74224 13.6032C8.09624 14.2532 7.87192 15.1669 8.06928 16H4V4ZM15.087 12.95H19.6211C20.3709 12.95 21 13.565 21 14.35V18.6C21 19.385 20.3709 20 19.6211 20H16.2422C15.6075 20 15.1678 19.9943 14.8343 19.9746C14.5007 19.9549 14.3594 19.9251 14.3031 19.9091L14.2989 19.9079C14.2796 19.9024 14.2782 19.902 14.253 19.8839C14.1914 19.8396 14.0865 19.7498 13.8472 19.509L10.1609 15.7996C9.94638 15.5838 9.94638 15.2288 10.1609 15.013C10.3476 14.8251 10.6361 14.8063 10.8405 14.9553L14.0186 17.2722V8.55C14.0186 8.23448 14.2695 8 14.5528 8C14.8361 8 15.087 8.23448 15.087 8.55V12.95Z"
            fill={color}
          />
        </svg>
      );
    case 'riskcontrol':
    case 'real-time-decisioning':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18ZM11 20C13.1287 20 15.0847 19.261 16.6256 18.0255L19.3356 20.7355C19.7261 21.126 20.3593 21.126 20.7498 20.7355C21.1403 20.345 21.1403 19.7118 20.7498 19.3213L18.0383 16.6097C19.2661 15.0713 20 13.1214 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM10 13V6H12V13H10ZM10 16V14H12V16H10Z"
            fill={color}
          />
        </svg>
      );
    case 'release-notes':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 12V19H5L5 5H12V3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V12H19ZM20.4351 7.94992C21.2162 7.16888 21.2162 5.90253 20.4352 5.12147L19.7281 4.41436C18.947 3.63332 17.6807 3.63331 16.8997 4.41433L9.12132 12.1924L8.76794 16.0816L12.6569 15.7279L20.4351 7.94992ZM11.7546 13.8017L20.4352 5.12147L19.021 6.53568L18.3139 5.82857L11.0476 13.0946L10.9769 13.8725L11.7546 13.8017Z"
            fill={color}
          />
        </svg>
      );
    case 'reporting':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7344 15.3202C18.5354 14.0741 19 12.5913 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C13.1038 19 15.0179 18.1879 16.446 16.8602L19.2929 19.7071C19.6834 20.0976 20.3166 20.0976 20.7071 19.7071C21.0976 19.3166 21.0976 18.6834 20.7071 18.2929L17.7344 15.3202ZM17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11Z"
            fill={color}
          />
          <path d="M8 8H14V10H8V8Z" fill={color} />
          <path d="M8 12H12V14H8V12Z" fill={color} />
        </svg>
      );
    case 'transactions':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.41421 9L11.7071 6.70711L10.2929 5.29289L7.14645 8.43934C6.2015 9.38429 6.87075 11 8.20711 11H17V9H9.41421Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5858 15L12.2929 17.2929L13.7071 18.7071L16.8536 15.5607C17.7985 14.6157 17.1293 13 15.7929 13H7V15H14.5858Z"
            fill={color}
          />
        </svg>
      );
      case 'ux-toolkit':
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.0134 10.8412L22.5192 11.1362C23.1807 11.5221 23.1807 12.4779 22.5192 12.8638L12.5039 18.7061C12.1925 18.8877 11.8075 18.8877 11.4961 18.7061L1.48075 12.8638C0.819244 12.4779 0.819242 11.5221 1.48075 11.1362L1.9866 10.8412L12 16.6846L22.0134 10.8412Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.0134 15.84L22.5192 16.1351C23.1807 16.521 23.1807 17.4768 22.5192 17.8626L12.5039 23.7049C12.1925 23.8866 11.8075 23.8866 11.4961 23.7049L1.48075 17.8626C0.819244 17.4768 0.819242 16.521 1.48075 16.1351L1.9866 15.84L12 21.6835L22.0134 15.84Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.0307 7.00001L12 11.6846L3.96925 7.00001L12 2.31542L20.0307 7.00001ZM12.5039 13.7061L22.5192 7.86379C23.1807 7.47791 23.1807 6.52211 22.5192 6.13623L12.5039 0.293936C12.1925 0.112308 11.8075 0.112308 11.4961 0.293936L1.48075 6.13623C0.819242 6.52211 0.819244 7.47791 1.48075 7.86379L11.4961 13.7061C11.8075 13.8877 12.1925 13.8877 12.5039 13.7061Z"
              fill={color}
            />
          </svg>
        );
    case 'webhooks':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 17L5.95176 16.4759L10.8453 8H13.1547L18.1603 16.6699L17.5 17L17.25 18H7.25L7 17ZM8.53591 16L12 10L15.4641 16H8.53591Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 19C5.55228 19 6 18.5523 6 18C6 17.4477 5.55228 17 5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19ZM19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17C18.4477 17 18 17.4477 18 18C18 18.5523 18.4477 19 19 19ZM12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7ZM12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9ZM8 18C8 19.6569 6.65685 21 5 21C3.34315 21 2 19.6569 2 18C2 16.3431 3.34315 15 5 15C6.65685 15 8 16.3431 8 18ZM22 18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18C16 16.3431 17.3431 15 19 15C20.6569 15 22 16.3431 22 18Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};
SidenavIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
};

SidenavIcon.defaultProps = {
  type: 'home',
  color: '#A7A8BD',
};

export default SidenavIcon;
